import request from '../tools/request'
import { HTTP } from './http'
const { downFileGET, downFilePost, POST } = request

// ! 导出类api
// 考核类别物料导出
export const EXPORT_EXAMINECATEGORY = (params: {
  examineCategoryCode: string
}) => downFileGET(`${HTTP}/excel/exportProductByExamineCategory`, params)

// 失败信息
export const EXPORT_ERRORDATA = (params: {
  id: string
  executeState?: string
}) => downFileGET(`${HTTP}/mission/exportMissionDetail`, params)

// 去存列表导出
export const EXPORT_SUPPLIER_ORDER = (params: any) =>
  POST(`${HTTP}/supplierOrder/exportSupplierOrder`, params, 'application/json')

/**
 * 导出订单
 * @returns
 */
export const ORDER_EXPORT_ORDER_DETAIL = (params: { ids: string[] }) =>
  downFilePost(`${HTTP}/order/exportOrderDetail`, params, 'application/json')
import request from '../tools/request'
import { HTTP } from './http'
const { downFileGET, downFilePost, POST } = request

// ! 导出类api
// 考核类别物料导出
export const EXPORT_EXAMINECATEGORY = (params: {
  examineCategoryCode: string
}) => downFileGET(`${HTTP}/excel/exportProductByExamineCategory`, params)

// 失败信息
export const EXPORT_ERRORDATA = (params: {
  id: string
  executeState?: string
}) => downFileGET(`${HTTP}/mission/exportMissionDetail`, params)

// 去存列表导出
export const EXPORT_SUPPLIER_ORDER = (params: any) =>
  POST(`${HTTP}/supplierOrder/exportSupplierOrder`, params, 'application/json')

/**
 * 导出订单
 * @returns
 */
export const ORDER_EXPORT_ORDER_DETAIL = (params: { ids: string[] }) =>
  downFilePost(`${HTTP}/order/exportOrderDetail`, params, 'application/json')
